<!------------------------------

      Page Actions

------------------------------->

@if (!isInIntegratedContext && !isInModalContext) {
  <ng-container *sbPageAction>
    <button
      *ngPermissions="permissionService.Permission.targeting_create"
      type="button"
      sb-button-primary
      [color]="'green'"
      [icon]="'plus'"
      [loading]="loading()"
      [iconButton]="true"
      (click)="addNewTargeting()"
      [disabled]="showSideBar"
      sbTooltip="{{ 'nav.network.targeting.create' | translate }}"
    >
    </button>

    <button
      type="button"
      sb-button-primary
      color="blue"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
      container="body"
      [iconButton]="true"
      [icon]="'refresh'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()">
    </button>

    <button
      type="button"
      sb-button-primary
      [color]="'blue'"
      [icon]="'barChart'"
      [loading]="loading()"
      [iconButton]="true"
      (click)="showDiurnalTargeting()"
      sbTooltip="{{ 'lang.targeting.diurnalTargets' | translate }}"
    >
    </button>
  </ng-container>
}

<!------------------------------

    Side Panel

------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="600">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="editableTargeting?.id">{{ 'nav.network.targeting.edit' | translate }}</h4>
    <h4 *ngIf="!editableTargeting?.id">{{ 'nav.network.targeting.create' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-targeting-edit [targeting]="editableTargeting" (editTargeting)="editTargeting($event)"></sb-page-targeting-edit>
</ng-template>

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'nav.network.targeting' | translate}}"
  [isInIntegratedContext]="isInIntegratedContext"
  [isInModalContext]="isInModalContext"
  [itemsData]="targetings"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'targetings'">

  <!------------------------------

  Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      @if (permissionService.hasPermission(permissionService.Permission.company_list)) {
        <sb-filter-section title="{{'lang.globals.company' | translate}}"
                           icon="company">
          <sb-filter-dto-list-select filterID="companies" [endpoint]="api.shared_Company_retrieveAll.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
      }

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.customer' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th>
        {{ 'lang.targeting.relation' | translate }}
      </th>
      <th>
        {{ 'lang.targeting.target' | translate }}
      </th>
      <th>
        {{ 'lang.targeting.amount' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-targeting>
    @let isSelected = targeting?.id === selectedTargeting?.id;
    <tr [ngClass]="{'selected': isSelected}">
      <td>
        {{ targeting?.id }}
      </td>
      <td>
        <span [innerHTML]="targeting?.name |truncate:20"></span>
      </td>
      <td>
        <span [innerHTML]="targeting?.description |truncate:20"></span>
      </td>
      <td>
        {{ targeting?.customer?.name }}
      </td>
      <td>
        <sb-comp-display-modified [data]="targeting"></sb-comp-display-modified>
      </td>
      <td>
        {{ targeting?.relation }}
      </td>
      <td>
        {{ targeting?.target }}
      </td>
      <td>
        {{ targeting?.amount | sbNumberFormat }}
      </td>
      <td class="sticky-col last-col">
        @if (isInModalContext || isInIntegratedContext) {
          <button
            sb-button-secondary
            [iconButton]="true"
            [color]="'blue'"
            [icon]="targeting?.id === selectedTargeting?.id ? 'boxChecked' : 'box'"
            [ngbTooltip]="'lang.globals.select' | translate"
            (click)="selectTargeting(targeting)">
          </button>
        } @else {
          <sb-split-button
            [splitButtonItems]="targeting.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(targeting, $event)"
          ></sb-split-button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
